<template>
  <vs-table :data="data">
    <template slot="header">
      <div class="con-input-search vs-table--search">
        <input
          class="input-search vs-table--search-input"
          type="text"
          v-model="text"
          @keypress.enter="search"
        />
        <vs-icon icon="search"></vs-icon>
      </div>
      <vs-button
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-filter"
        class="mx-2"
        radius
        @click="openFilter"
      ></vs-button>
    </template>
    <template slot="thead">
      <vs-th>
        {{ $t('mail') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('subject') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('date') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('vendor') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('comment') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('status') | capitalize }}
      </vs-th>
      <!-- <th class="qb-sticky">
        {{ $t('actions') }}
      </th> -->
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].mail }}
        </vs-td>
        <vs-td>
          {{ data[i].subject }}
        </vs-td>
        <vs-td>
          {{ formatDate(data[i].mail_date, 'MM/DD/YYYY HH:mm') }}
        </vs-td>
        <vs-td>
          {{ data[i].vendor_name }}
        </vs-td>
        <vs-td>
          {{ data[i].comment }}
        </vs-td>
        <vs-td>
          <vs-chip :color="data[i].status_color">
            {{
              $i18n.locale === 'us'
                ? data[i].status_name
                : data[i].status_name_esp
            }}
          </vs-chip>
        </vs-td>
        <!-- <vs-td>
          <div>
            <action-icon
              icon="ArrowRightCircleIcon"
              :tooltip="$t('details')"
              @click="showDetails(data[i].id)"
            />
          </div>
        </vs-td> -->
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import mixins from '@/mixins'

export default {
  components: {
    ActionIcon,
    ThSort,
  },
  data() {
    return {
      text: '',
    }
  },
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
    openFilter() {
      this.$emit('openFilter')
    },
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
</style>
